import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import StockApi, { SearchStockParam } from './api/StockApi';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import StockModel from './models/StockModel';
import CustomModal from '../CustomModal/CustomModal';
import { Autocomplete, AutocompleteChangeDetails, Button, Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import StartEndDatepicker from '../StartEndDatepicker/StartEndDatepicker';
import Api from '../../app/apiRequest';
import { StockSearchSelector, setQueryDateFrom, setQueryDateTo, setQueryItem, setShowStockDetailModal, setStockDetails, setTriggerRefreshStockDetail } from './reducers/StockSearchReducer';
import { StockInputSelector, setSelectedStockId } from './reducers/StockInputReducer';
import StockInput from './StockInput';
import CustomAccordion from '../CustomAccordion/CustomAccordion';

const StockDetailModal: React.FunctionComponent = () => {
    let dispatch = useDispatch();
    const stockSearchlData = useSelector(StockSearchSelector);
    const StockInputViewData = useSelector(StockInputSelector);

    useEffect(() => {
        if (stockSearchlData.triggerSearchStockDetail > 0) {
            dispatch(showLoading(true));
            StockApi.GetByItem(stockSearchlData.query).then((response: BaseResponse<StockModel[]>) => {
                if (response.success) {
                    dispatch(setStockDetails(response.data));

                    dispatch(showLoading(false));

                    dispatch(setTriggerRefreshStockDetail(0));
                } else {
                    Utility.Alert.Error(response.message);
                    dispatch(showLoading(false));
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
                dispatch(showLoading(false));
            })
        }
    }, [stockSearchlData.triggerSearchStockDetail]);

    return <>
        <CustomModal
            open={stockSearchlData.showStockDetailModal}
            onClose={() => {
                dispatch(setShowStockDetailModal(false));
            }}
            className='Stock-account-modal'
        >
            <CustomAccordion
                title="Search"
                defaultOpen={true}
                className="top-quick-input"
                disableHideButton={true}
            >
                <Grid container>
                    <Grid item lg={3} xs={12}>
                        <Autocomplete
                            className='cargo-input-component'
                            freeSolo={true}
                            options={StockInputViewData.stockItems}
                            renderInput={(params) => <TextField {...params} label="Items" />}
                            value={stockSearchlData.query.item}
                            onChange={(event: React.SyntheticEvent, value: string | null, reason: string, details?: AutocompleteChangeDetails<string> | undefined) => {
                                dispatch(setQueryItem(value ? value : ""));
                            }}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <StartEndDatepicker
                            startDateLabel="Date From"
                            endDateLabel="Date To"
                            className="fixture-search-item"
                            useQuickEndDateInput={false}
                            onStartDateChange={(date: string) => {
                                dispatch(setQueryDateFrom(date));
                            }}
                            onEndDateChange={(date: string) => {
                                dispatch(setQueryDateTo(date));
                            }}
                            startDateValue={stockSearchlData.query.dateFrom}
                            endDateValue={stockSearchlData.query.dateTo}
                            allowFreeInput={true}
                        >
                        </StartEndDatepicker>
                    </Grid>
                    <Grid item lg={3} xs={12}>
                        <Button
                            fullWidth
                            variant="contained"
                            className="tonnage-search-save-button"
                            onClick={() => {
                                dispatch(setTriggerRefreshStockDetail((new Date()).getTime()));
                            }}
                        >
                            RUN SEARCH (w)
                        </Button>
                    </Grid>
                </Grid>
            </CustomAccordion>
            <StockInput>
            </StockInput>
            <Grid
                container
                justifyContent="flex-end"
                className="table-search-result-utility-bar"
            >
                <Button
                    color="secondary"
                    variant='outlined'
                    className='table-search-result-utility-bar-item'
                    onClick={() => {
                        let url = Api.constructGetUrl("/api/Stock/ExportExcel", stockSearchlData.query);

                        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                        if (newWindow) newWindow.opener = null
                    }}
                >Export Excel</Button>
            </Grid>
            <Grid>
                <Table className="datatable Stock-table">
                    <TableHead>
                        <TableRow className="datatable-head">
                            <TableCell rowSpan={2}>Date</TableCell>
                            <TableCell rowSpan={2}>Description</TableCell>
                            <TableCell colSpan={2}>Buy</TableCell>
                            <TableCell colSpan={3}>Sell</TableCell>
                            <TableCell colSpan={2}>Closing</TableCell>
                        </TableRow>
                        <TableRow className="datatable-head">
                            <TableCell>Buy Amount</TableCell>
                            <TableCell>Buy Value</TableCell>
                            <TableCell>Sell Amount</TableCell>
                            <TableCell>Cost</TableCell>
                            <TableCell>Sell Value</TableCell>
                            <TableCell>Amount</TableCell>
                            <TableCell>Total Value</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            _.map(stockSearchlData.stockDetails, (stock, index) => {
                                return <TableRow onClick={() => {
                                    dispatch(setSelectedStockId(stock.id));
                                }}>
                                    <TableCell>{Utility.DateFormat.formatDateString(stock.date)}</TableCell>
                                    <TableCell>{stock.description}</TableCell>
                                    <TableCell>{Math.round(stock.buyAmount).toLocaleString('en-US')}</TableCell>
                                    <TableCell>{stock.buyAmount ? Math.round(stock.totalValue).toLocaleString('en-US') : ""}</TableCell>
                                    <TableCell>{Math.round(stock.sellAmount).toLocaleString('en-US')}</TableCell>
                                    <TableCell>{Math.round(stock.cost).toLocaleString('en-US')}</TableCell>
                                    <TableCell>{stock.sellAmount ? Math.round(stock.totalValue).toLocaleString('en-US') : ""}</TableCell>
                                    <TableCell>{Math.round(stock.closingAmount).toLocaleString('en-US')}</TableCell>
                                    <TableCell>{Math.round(stock.closingTotalValue).toLocaleString('en-US')}</TableCell>
                                </TableRow>
                            })
                        }
                    </TableBody>
                </Table>
            </Grid>
        </CustomModal >
    </>
};

export default StockDetailModal;